import React from "react";
import Reveal from "../common/Reveal";

const UNITS = [
  {
    title: "기업부설연구소",
    desc: "기술 연구개발 전담 조직",
  },
  {
    title: "솔루션사업부",
    desc: "MES·AI 솔루션 개발 및 사업 총괄",
    sub: [
      { title: "제품개발팀", children: ["웹플랫폼팀", "AI개발팀"] },
      { title: "사업기획팀", children: [] },
    ],
  },
  {
    title: "경영지원팀",
    desc: "인사·재무·행정 지원",
  },
];

const OrgChart = () => {
  return (
    <section className="bg-primary-50/40 py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <span className="text-sm font-semibold uppercase tracking-wide text-accent-600">
            Organization
          </span>
          <h2 className="mt-3 break-keep text-3xl font-bold text-primary-900 sm:text-4xl">
            조직도
          </h2>
        </Reveal>

        {/* 대표이사 */}
        <div className="mt-12 flex flex-col items-center">
          <div className="rounded-lg bg-primary-800 px-8 py-3 text-base font-semibold text-white shadow-md">
            대표이사
          </div>
          <div className="h-8 w-px bg-primary-300" />
        </div>

        {/* 산하 조직 + 연결선 (한 그리드 안에서 1행: 연결선, 2행: 카드 — gap-6(24px)을 정확히 계산해 끊김 없이 연결) */}
        <div className="grid grid-cols-1 gap-y-6 md:grid-cols-3 md:gap-x-6 md:gap-y-0">
          {UNITS.map((unit, i) => (
            <div key={`stem-${unit.title}`} className="relative hidden h-8 md:block">
              {/* 이 카드로 내려오는 세로선 */}
              <div className="absolute left-1/2 top-0 h-full w-px -translate-x-1/2 bg-primary-300" />
              {/* 옆 카드와 이어지는 가로선 (gap 영역까지 -right-3/-left-3로 확장해 끊김 방지) */}
              {i === 0 && (
                <div className="absolute left-1/2 -right-3 top-0 h-px bg-primary-300" />
              )}
              {i === 1 && (
                <div className="absolute -left-3 -right-3 top-0 h-px bg-primary-300" />
              )}
              {i === 2 && (
                <div className="absolute -left-3 right-1/2 top-0 h-px bg-primary-300" />
              )}
            </div>
          ))}

          {UNITS.map((unit, index) => (
            <Reveal
              key={unit.title}
              delay={index * 100}
              className="rounded-xl border border-gray-100 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <h3 className="text-lg font-semibold text-primary-900">
                {unit.title}
              </h3>
              <p className="mt-1 break-keep text-sm text-gray-600">{unit.desc}</p>

              {unit.sub && (
                <div className="mt-5 space-y-3 border-t border-gray-100 pt-5">
                  {unit.sub.map((s) => (
                    <div key={s.title}>
                      <span className="inline-block rounded-md bg-primary-50 px-3 py-1.5 text-sm font-medium text-primary-700">
                        {s.title}
                      </span>
                      {s.children.length > 0 && (
                        <div className="mt-2 flex flex-wrap gap-2 pl-3">
                          {s.children.map((c) => (
                            <span
                              key={c}
                              className="rounded-md bg-accent-50 px-2.5 py-1 text-xs font-medium text-accent-700"
                            >
                              {c}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OrgChart;
